import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { FiLock, FiMail, FiAlertCircle } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { admin, loginAdmin } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in
  if (admin) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await api.adminLogin(formData.email, formData.password);
      loginAdmin(data.admin, data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      padding: '24px'
    },
    card: {
      background: 'white',
      borderRadius: '16px',
      padding: '48px',
      width: '100%',
      maxWidth: '420px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    logo: {
      textAlign: 'center',
      marginBottom: '32px'
    },
    logoText: {
      fontSize: '1.75rem',
      fontWeight: '700',
      color: '#1a3a5c'
    },
    logoSub: {
      color: '#555',
      marginTop: '4px'
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      textAlign: 'center',
      marginBottom: '8px'
    },
    subtitle: {
      color: '#555',
      textAlign: 'center',
      marginBottom: '32px'
    },
    error: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      background: '#FFEBEE',
      color: '#C62828',
      padding: '12px 16px',
      borderRadius: '8px',
      marginBottom: '24px',
      fontSize: '0.875rem'
    },
    inputGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      fontWeight: '500',
      marginBottom: '8px',
      color: '#222'
    },
    inputWrapper: {
      position: 'relative'
    },
    inputIcon: {
      position: 'absolute',
      left: '14px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#555'
    },
    input: {
      width: '100%',
      padding: '14px 14px 14px 44px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '1rem',
      transition: 'border-color 0.2s'
    },
    btn: {
      width: '100%',
      padding: '14px',
      background: '#1a3a5c',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      marginTop: '8px'
    },
    btnDisabled: {
      opacity: 0.7,
      cursor: 'not-allowed'
    },
    footer: {
      textAlign: 'center',
      marginTop: '24px',
      color: '#555',
      fontSize: '0.875rem'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.logoText}>Kasbia Stays</div>
          <div style={styles.logoSub}>Admin Portal</div>
        </div>

        <h1 style={styles.title}>Welcome Back</h1>
        <p style={styles.subtitle}>Sign in to access the admin panel</p>

        {error && (
          <div style={styles.error}>
            <FiAlertCircle />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email Address</label>
            <div style={styles.inputWrapper}>
              <FiMail style={styles.inputIcon} />
              <input
                type="email"
                style={styles.input}
                placeholder="admin@kasbiastays.co.uk"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <div style={styles.inputWrapper}>
              <FiLock style={styles.inputIcon} />
              <input
                type="password"
                style={styles.input}
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            style={{ ...styles.btn, ...(loading ? styles.btnDisabled : {}) }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={styles.footer}>
          Protected area. Unauthorized access prohibited.
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
